import React, { useEffect, useState } from 'react';
import { Box, Grid, CircularProgress, useTheme, useMediaQuery } from '@mui/material';
import { keyframes } from '@mui/system';
import PropTypes from 'prop-types';

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const Loader = ({ loading = false, label, size = 'medium', style }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [width, setWidth] = useState(isMobile ? "100%" : "84%");

  useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth < theme.breakpoints.values.sm ? "100%" : "84%");
    };

    window.addEventListener('resize', handleResize);
    handleResize(); // Initial check

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [theme.breakpoints.values.sm]);

  const getSize = () => {
    const sizes = {
      small: 30,
      medium: 40,
      large: 50
    };
    return sizes[size] || sizes.medium;
  };
  
  if (!loading) return null;
  return (
    <Box
      role="progressbar"
      aria-label={label}
      sx={{
        position: 'fixed',
        top: 0,
        right: 0,
        display: 'flex',
        width,
        height: '100vh',
        backgroundColor: 'rgba(0, 0, 0, 0.05)',
        zIndex: 9999,
        backdropFilter: 'blur(5px)',
        animation: `${fadeIn} 0.3s ease-in-out`,
        transition: 'all 0.3s ease-in-out',
        ...style
      }}
    >
      <Grid
        container
        spacing={2}
        direction="column"
        alignItems="center"
        justifyContent="center"
        sx={{ minHeight: '100vh' }}
      >
        <Grid item>
          <CircularProgress 
            size={getSize()}
            sx={{
              color: 'var(--brand-color)',
            }} 
          />
        </Grid>
        {label && <Grid item>
          <p
            style={{
              color: 'var(--primary)',
              fontSize: 'var(--medium-text)',
              fontWeight: '600',
              margin: 0,
              marginTop: '1rem',
            }}
          >
            {label}
          </p>
        </Grid>}
      </Grid>
    </Box>
  );
};

Loader.propTypes = {
  loading: PropTypes.bool,
  label: PropTypes.string,
  size: PropTypes.oneOf(['small', 'medium', 'large'])
};

export default Loader;